module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/get-started.json
// module id = 524
// module chunks = 247112542583941